import { render, staticRenderFns } from "./shops-admin-list-settings-modal.vue?vue&type=template&id=23ad2526&scoped=true"
import script from "./shops-admin-list-settings-modal.vue?vue&type=script&lang=js"
export * from "./shops-admin-list-settings-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ad2526",
  null
  
)

export default component.exports